module.exports = __webpack_public_path__ + "37bb2fc6e90b95ba89795386d5856533.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/avocado.png
// module id = 2353
// module chunks = 0